<template>
  <div class="company">
    <h5 class="company__title">合作伙伴</h5>
    <div class="wrapper">
      <!-- <h5 class="company__desc">开拓产品资源新渠道，实现客户量与利润双增长</h5> -->
      <div class="company__wrapper">
        <ul>
          <li class="company__item" ref="li" :class="{'company__item--active': itemIndex == 2}" v-for="(item, itemIndex) in [...companies, ...companies, ...companies]" :key="itemIndex">
            <div class="company__item__wrapper">
              <el-image fit="cover" class="company__img" :src="item.bg"></el-image>
              <el-image fit="cover" class="company__logo" :src="item.logo"></el-image>
              <h4 class="company__name">{{item.name}}</h4>
              <div class="company__intro">{{item.desc}}</div>
              <div class="company__count">
                <p class="company__count__num">{{item.num}}</p>
                <p class="company__count__title">{{item.num_desc}}</p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CompanyScroll",
  data() {
    return {
      companies: [
        {
          name: "湖北皇家长江旅游船有限公司",
          desc: "湖北东方皇家旅游船公司成立于1994年，是长江上公认的豪华游船先行者，公司旗下游轮接待过不计其数的高端客户如世界总裁协会，美国时代华纳集团董事会等，1995年比尔盖茨和巴菲特曾连袂包租东方皇后号游轮。",
          num: "3000+",
          num_desc: "累计服务游客",
          bg: require("@/assets/img/home/company_1_bg.png"),
          logo: require("@/assets/img/home/company_1_logo.png"),
        },
        {
          name: "北京恒信国际旅行社有限公司",
          desc: "作为中国领先的游轮游运营商，恒信旅游坚持以服务品质为前提，以产品为核心，整合游轮签证、游轮岸上观光、岸上交通等游轮游产业链各要素资源，是游轮旅游产品的制造者和服务的提供者。",
          num: "49万+",
          num_desc: "单日最高交易金额",
          bg: require("@/assets/img/home/company_2_bg.png"),
          logo: require("@/assets/img/home/company_2_logo.png"),
        },
        {
          name: "北京柒海假期国际旅行社有限公司",
          desc: "七海假期国际旅行社，是一家以邮轮、南北极探险和定制旅游规划为主要核心商品的「旅游服务商」。团队成员由拥有超过 30 年旅行社经营经验的专业经理人、足迹遍布五大洋七大洲南北极的专业领队，和一群对旅行充满热情的年轻伙伴们所组成。",
          num: "10%",
          num_desc: "平均每单佣金可达",
          bg: require("@/assets/img/home/company_3_bg.png"),
          logo: require("@/assets/img/home/company_3_logo.png"),
        },
        {
          name: "云南豆豆假期国际旅行社有限公司",
          desc: "创立于1998年，旗下有“畅游”同业品牌、“ME TIME真我时光”定制旅游、“开启明天”夏令营策划组织机构等品牌，业务涵盖省内地接、国内组团、出境组团、主题旅游、企划中心等板块。",
          num: "32万+",
          num_desc: "最高单日成交金额",
          bg: require("@/assets/img/home/company_4_bg.png"),
          logo: require("@/assets/img/home/company_4_logo.png"),
        },
        {
          name: "北京冠达之旅国际旅行社有限公司",
          desc: "冠达旅游创立于2021年7月，面向俄罗斯、欧洲市场，通过开发有特色出境口岸的包机，形成冠达旅游有特色的产品体系，打造综合性目的地旅游批发业务、国内外游轮旅游定制、高端私人 定制、会议会展的综合服务公司。",
          num: "100人",
          num_desc: "入驻仅一周累计收客突破",
          bg: require("@/assets/img/home/company_5_bg.png"),
          logo: require("@/assets/img/home/company_5_logo.png"),
        },
        {
          name: "重庆洲际国际旅行社有限责任公司",
          desc: "“洲际之旅”-重庆洲际国际旅行社有限责任公司精心打造的高端旅游度假品牌，致力于为高端客户提供个性化的商旅服务产品以及更优质舒适的旅游度假体验。在长期而专注的工作中，积累了操作企业奖励旅游、各商会组织商务考察、高端商务客户休闲度假的丰富经验。",
          num: "330万",
          num_desc: "累计成交金额突破",
          bg: require("@/assets/img/home/company_6_bg.png"),
          logo: require("@/assets/img/home/company_6_logo.png"),
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
.company {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  padding-top: 6.25rem;
  padding-bottom: 5rem;
}
.company__title {
  font-weight: 600;
  font-size: 40px;
  line-height: 1;
  position: relative;
  text-align: center;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.company__title::after {
  content: '';
  --tw-bg-opacity: 1;
  background-color: rgba(0, 94, 220, var(--tw-bg-opacity));
  border-radius: 9999px;
  height: 0.25rem;
  margin-left: -3.5rem;
  position: absolute;
  left: 50%;
  bottom: -1.25rem;
  width: 7rem;
}
.company__desc {
  color: #adb5bd;
  font-size: 22px;
  padding-bottom: 30px;
  text-align: center;
}
.company ul {
  white-space: nowrap;
}
.company__item {
  display: inline-block;
  vertical-align: top;
  position: relative;
  width: 350px;
  height: 420px;
  margin-right: 30px;
  flex-shrink: 0;
}
.company__item__wrapper {
  width: 350px;
  height: 420px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0px 8px 24px 0px #f1f3f5;
  text-align: center;
  background-color: #fff;
  transition: all 0.3s;
  position: absolute;
  top: 0;
}
.company__item:hover .company__item__wrapper {
  top: -20px;
}
.company__img {
  width: 350px;
  height: 142px;
}
.company__logo {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  width: 72px;
  height: 72px;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  top: 106px;
}
.company__name {
  color: #1f2128;
  font-size: 18px;
  font-weight: 500;
  padding-top: 50px;
  padding-bottom: 5px;
}
.company__intro {
  display: inline-block;
  padding: 0 40px;
  color: #868e96;
  font-size: 13px;
  word-wrap: break-word;
  word-break: break-all;
  white-space: pre-wrap;
}
.company .company__count {
  position: absolute;
  width: 100%;
  bottom: 20px;
}
.company .company__count__num {
  color: #212529;
  font-size: 23px;
  font-weight: 600;
}
.company .company__count__title {
  color: #adb5bd;
  font-size: 13px;
}
.company__wrapper {
  width: 100%;
  overflow-x: hidden;
  padding-top: 50px;
  padding-bottom: 20px;
}
.company__wrapper ul {
  align-items: center;
  display: flex;
  position: relative;
  animation: 100000ms linear 0s infinite normal forwards running ExCaseStyle;
}
.company__wrapper ul:hover {
  animation-play-state: paused;
}
.company__wrapper ul.forwards {
  animation: 100000ms linear 0s infinite normal forwards running
            ExCaseStyle;
}
.company__wrapper ul.paused {
  animation: 100000ms linear 0s infinite normal paused running ExCaseStyle;
}
.wrapper {
  margin-top: 2.5rem;
}
</style>


<style>

@keyframes ExCaseStyle {
  from {
    left: -278px;
  }
  to {
    left: -2770px;
  }
}

</style>